import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'
import { applicantsAdapter } from './Slice'
/**
 * Select form data
 */
export const selectApplicantsState = createSelector(
  (state: RootState) => state,
  (state) => state.applicants
)

export const {
  selectById: selectApplicantById,
  selectAll: selectApplicants,
  selectEntities: selectApplicantEntities,
} = applicantsAdapter.getSelectors<RootState>((state) => state.applicants)
